import _ from 'lodash';
import { forEach } from 'p-iteration';
import { GET_MODULES } from '../graphql/modules.js';
import { GET_INFOUSER } from '../graphql/user.js';

export const getDataModules = async (client) => {
  try {
    // from cache
    return await client.readQuery({ query: GET_MODULES }).Modules;
  } catch (err) {
    // from server
    return await client.query({ query: GET_MODULES }).then(({ data: { Modules } }) => {
      return Modules;
    });
  }
};

export const getModulesData = async (client) => {
  // return all modules actived
  const Modules = await getDataModules(client);

  return Promise.all(
    Modules.map(async (Module) => {
      if (Module.actived) {
        try {
          const jsonData = await import(
            `@betwixt/common/modules/${Module.moduleId}/module.json`
          ).then((m) => m.default);
          return Object.assign({}, Module, jsonData);
        } catch (err) {
          console.log(err);
        }
      }
    })
  );
};

export const getModulesActived = async (routes, client) => {
  const Modules = await getDataModules(client);

  // return all routes actives for the user
  return routes.map((item) => {
    const Module = _.find(Modules, { moduleId: item });

    if (Module && Module.actived === true) {
      return item;
    } else return false;
  });
};

export const extendModules = async (modulesActived) => {
  // CLONATO DA SERVER --- TO DO
  let collection = [];

  await forEach(modulesActived, async (moduleId) => {
    try {
      const moduleConfig = await import(`@betwixt/common/modules/${moduleId}/module.json`).then(
        (m) => m.default
      );
      collection.push(moduleConfig);
    } catch (err) {
      console.log(err);
    }
  });

  return collection;
};

export const setSRModules = async (client) => {
  //console.log("*************** setSRModules");

  const User = await client.query({ query: GET_INFOUSER });
  const modulesActived = User.data.User.modulesActived;

  await forEach(modulesActived, async ({ module: { id } }) => {
    try {
      const schemas = await import(`../../src/modules/${id}/client/schema/default`).then(
        (m) => m.default
      );
      const moduleResolvers = await import(`../../src/modules/${id}/client/resolvers`).then(
        (m) => m.default
      );

      client.cache.writeData({
        data: schemas,
      });

      client.addResolvers(moduleResolvers);
    } catch (err) {
      console.log('error;');
    }
  });
};

export const getTypePolicies = async () => {
  const ModulesTypePolicies = await import('@betwixt/common/modules/__TypePolicies.json').then(
    (m) => m.default
  );
  let typePolicies = await import('@betwixt/my/src/typePolicies.js').then((m) => m.default);
  let typePoliciesModules = {};

  await Promise.all(
    ModulesTypePolicies.map(async (moduleId) => {
      try {
        const tpm = await import(`@betwixt/common/modules/${moduleId}/client/typePolicies.js`).then(
          (m) => m.default
        );
        typePoliciesModules = _.merge(typePoliciesModules, tpm);
      } catch (err) {}
    })
  );

  return _.merge(typePoliciesModules, typePolicies);
};

export const getModulePath = ({ module, moduleId, lang, gConfig }) => {
  if (module && moduleId && lang && gConfig)
    return `${gConfig.protocol}://${gConfig.sections.web.hostname}${module.routes.web[moduleId][lang]}`;
};
